import { separate } from '../components/PaymentHistory'

export const SUBJECT_SOLD_TYPES = {
  GAME: 0,
  VIDEO: 1,
}

export const emptySoldReport = {
  todayCount: 0,
  yesterdayCount: 0,
  weekCount: 0,
  monthCount: 0,
  totalCount: 0,
  todayIncome: 0,
  yesterdayIncome: 0,
  weekIncome: 0,
  monthIncome: 0,
  totalIncome: 0,
}

export const normalizeSoldReport = (data) => {
  if (!data) {
    return { ...emptySoldReport }
  }

  return {
    todayCount: data.todayCount ?? 0,
    yesterdayCount: data.yesterdayCount ?? 0,
    weekCount: data.weekCount ?? 0,
    monthCount: data.monthCount ?? 0,
    totalCount: data.totalCount ?? 0,
    todayIncome: data.todayIncome ?? 0,
    yesterdayIncome: data.yesterdayIncome ?? 0,
    weekIncome: data.weekIncome ?? 0,
    monthIncome: data.monthIncome ?? 0,
    totalIncome: data.totalIncome ?? 0,
  }
}

export const buildSoldTableData = (data) => {
  const report = normalizeSoldReport(data)

  return [
    {
      name: 'تعداد فروش',
      today: report.todayCount,
      yesterday: report.yesterdayCount,
      week: report.weekCount,
      months: report.monthCount,
      total: report.totalCount,
      key: 'sold-count',
    },
    {
      name: 'درآمد (ریال)',
      today: separate(report.todayIncome),
      yesterday: separate(report.yesterdayIncome),
      week: separate(report.weekIncome),
      months: separate(report.monthIncome),
      total: separate(report.totalIncome),
      key: 'sold-income',
    },
  ]
}
